import { Card } from "antd";

export function PageHeader({ title, subtitle, metricLabel, metricValue }) {
  return (
    <div className="te-page-header-grid">
      <div className="te-panel" style={{ padding: 24 }}>
        <h2 className="te-page-title">{title}</h2>
        {subtitle ? <p className="te-page-subtitle">{subtitle}</p> : null}
      </div>

      {metricLabel !== undefined ? (
        <Card className="te-card">
          <span className="te-muted">{metricLabel}</span>
          <div className="te-page-header-grid__metric">{metricValue}</div>
        </Card>
      ) : null}
    </div>
  );
}
